/**
 * SmtpSetting(送信元)関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'
import OptionState from './OptionState'

class SmtpSettingOptionState extends Record(OptionState) {
  mergeModel(model) {
    return this.merge({
      label: model.user_name,
      value: model.id
    })
  }
}

export default SmtpSettingOptionState
